// This file is generated by a script. Do not edit this file directly.
var _excluded = ["children", "title", "isGroup"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import { components } from 'react-select';
import { Heading } from "../Typography";
/**
 * This component is used to limit the number of options in the menu list
 * and group.
 * It is used to prevent the menu list from becoming too long and to
 * make the menu list more readable.
 */
export var LimitedOptionsList = function LimitedOptionsList(_ref) {
  var children = _ref.children,
    title = _ref.title,
    isGroup = _ref.isGroup,
    props = _objectWithoutProperties(_ref, _excluded);
  if (isGroup) {
    return /*#__PURE__*/React.createElement(components.Group, props, children);
  }
  return /*#__PURE__*/React.createElement(components.MenuList, props, title && /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-items-center cop-px-3 cop-pb-1 cop-pt-2"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xs",
    className: "cop-text-secondary"
  }, title)), children);
};
